import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=2c8a5cdd&scoped=true"
import script from "./Audit.vue?vue&type=script&lang=js"
export * from "./Audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a5cdd",
  null
  
)

export default component.exports